import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { areaDetails } from "@/mocks/areas";
import { AREA_PREVIEW_IMAGES, AREA_THUMB_IMAGES } from "@/config/heroImages";

export default function AreasPreviewSection() {
  // Newly added home-turf localities (around our Kannahalli / Anikethana Nagara base)
  // are surfaced first so the six newest area pages get prominent internal linking.
  const featuredSlugs = [
    "anikethana-nagara",
    "kannahalli",
    "giddenahalli",
    "seegehalli",
    "magadi-road",
    "nice-road",
  ];
  const areas = [
    ...areaDetails.filter((a) => featuredSlugs.includes(a.slug)),
    ...areaDetails.filter((a) => !featuredSlugs.includes(a.slug)),
  ];

  return (
    <section id="areas" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Areas we Serve"
          title="Local shifting across every Bangalore locality"
          subtitle="From Nagarabhavi in the west to Whitefield in the east, our crews know every neighbourhood's streets, lift timings and parking rules. Pick your area to open its dedicated local shifting page."
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {areas.map((area) => (
            <Link
              key={area.slug}
              to={`/areas-we-serve/${area.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-accent-300"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={AREA_PREVIEW_IMAGES[area.slug] ?? AREA_THUMB_IMAGES[area.slug]}
                  alt={`Packers and Movers in ${area.name}, Bangalore`}
                  title={`Packers and Movers in ${area.name}, Bangalore - Lahari`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
                  <i className="ri-map-pin-2-line" aria-hidden="true" />
                  {area.region}
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                  Packers and Movers in {area.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{area.summary}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                  View {area.name} services
                  <i
                    className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"
                    aria-hidden="true"
                  />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-9 text-center">
          <Link
            to="/areas-we-serve"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-map-2-line text-lg" aria-hidden="true" /> View all areas we serve
          </Link>
        </div>
      </div>
    </section>
  );
}